import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const QuestionIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Question",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18 27.82c0 1.2-.98 2.18-2.18 2.18s-2.18-.98-2.18-2.18.98-2.18 2.18-2.18 2.18.98 2.18 2.18m-2.18-4.77c-1.2 0-2.18-.98-2.18-2.18V17.6c0-1.2.98-2.18 2.18-2.18 2.5 0 4.53-2.03 4.53-4.53s-2.03-4.53-4.53-4.53c-1.99 0-3.67 1.28-4.29 3.05v.03c-.31.87-1.12 1.48-2.08 1.48-1.2 0-2.18-.98-2.18-2.18 0-.25.04-.49.12-.71v.02c1.22-3.54 4.53-6.04 8.42-6.04a8.89 8.89 0 0 1 8.89 8.89c0 4.14-2.82 7.61-6.65 8.61h-.06v1.38c0 1.2-.98 2.17-2.18 2.17Z"
    })
  }));
};